export const customer = {
  // Customer Dashboard
  totalBookings: 'Total des Réservations',
  noBookingsYet: 'Aucune réservation encore',
  startExploring: 'Commencez à explorer nos voitures pour faire votre première réservation !',
  recentBookings: 'Réservations Récentes',
  viewDetails: 'Voir les Détails',
  bookNewCar: 'Réserver une Nouvelle Voiture',
}; 